module.exports = __webpack_public_path__ + "static/media/la-corporate-catering-4.41ccf621.jpg";